import React from "react";
import { handleOutsideClick } from "../../../../Helpers/HandleOutsideClick";

const AddInterviewerModal = ({
  show,
  onClose,
  newInterviewer,
  setNewInterviewer,
  handleChange,
  handleKeyDown,
  handleSelectSuggestion,
  showSuggestions,
  activeField,
  suggestions,
  highlightedIndex,
  setFormData,
  formData,
  setShowSuggestions,
}) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center"
      onClick={(e) => handleOutsideClick(e, onClose)} >
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/40 backdrop-blur-sm"
        onClick={onClose}
      ></div>

      {/* Modal Box */}
      <div className="relative bg-white w-full max-w-md rounded-xl shadow-xl p-6 z-50">

        <h2 className="text-lg font-semibold mb-4">
          Add Interviewer
        </h2>

        {/* Interviewer Code */}
        <div className="mb-4 relative">
          <label className="block text-sm font-medium mb-1">
            Interviewer Code
          </label>

          <input
            type="text"
            name="interviewerCode"
            value={
              newInterviewer.interviewerDisplay ||
              newInterviewer.interviewerCode
            }
            onChange={handleChange}
            onBlur={() =>
              setTimeout(() => setShowSuggestions(false), 200)
            }
            onKeyDown={handleKeyDown}
            autoComplete="off"
            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />

          {/* Suggestions */}
          {showSuggestions &&
            activeField === "interviewerCode" &&
            suggestions.length > 0 && (
              <ul className="absolute left-0 right-0 mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-48 overflow-y-auto z-50">
                {suggestions.map((s, idx) => (
                  <li
                    key={idx}
                    onClick={() => handleSelectSuggestion(s)}
                    className={`px-3 py-2 cursor-pointer ${
                      highlightedIndex === idx
                        ? "bg-blue-500 text-white"
                        : "hover:bg-gray-100"
                    }`}
                  >
                    {s.employeeCode} - {s.employeeName}
                  </li>
                ))}
              </ul>
            )}
        </div>

        {/* Interview Round */}
        <div className="mb-6">
          <label className="block text-sm font-medium mb-1">
            Interview Round
          </label>

          <input
            type="number"
            min="1"
            value={newInterviewer.interviewSequence}
            onChange={(e) =>
              setNewInterviewer((prev) => ({
                ...prev,
                interviewSequence: Number(e.target.value),
              }))
            }
            className="w-full border border-gray-300 rounded-md px-3 py-2"
          />
        </div>

        {/* Buttons */}
        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 border rounded-md"
          >
            Cancel
          </button>

          <button
            onClick={() => {
              if (
                newInterviewer.interviewerCode &&
                newInterviewer.interviewerName
              ) {
                setFormData((prev) => ({
                  ...prev,
                  jobInterviewers: [
                    ...prev.jobInterviewers,
                    {
                      interviewerCode:
                        newInterviewer.interviewerCode,
                      interviewerName:
                        newInterviewer.interviewerName,
                       interviewerEmail:
                        newInterviewer.interviewerEmail,
                      interviewerDisplay: `${newInterviewer.interviewerCode} - ${newInterviewer.interviewerName}`,
                      interviewSequence:
                        prev.jobInterviewers.length + 1,
                    },
                  ],
                }));

                setNewInterviewer({
                  interviewerCode: "",
                  interviewerName: "",
                  interviewerEmail: "",
                  interviewSequence:
                    formData.jobInterviewers.length + 1,
                });

                onClose();
              } else {
                alert("Please enter valid interviewer code");
              }
            }}
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
          >
            Add
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddInterviewerModal;
